const BASE = import.meta.env.VITE_API_BASE || '/api/v1';
const TOK_KEY = 'chefhk_admin_access';
const REF_KEY = 'chefhk_admin_refresh';
const ROLE_KEY = 'chefhk_admin_role';
export function setTokens(access, refresh, role) {
    localStorage.setItem(TOK_KEY, access);
    localStorage.setItem(REF_KEY, refresh);
    if (role)
        localStorage.setItem(ROLE_KEY, role);
}
export function getAccess() { return localStorage.getItem(TOK_KEY) || ''; }
export function getRefresh() { return localStorage.getItem(REF_KEY) || ''; }
export function getRole() { return localStorage.getItem(ROLE_KEY) || ''; }
export function clearTokens() {
    localStorage.removeItem(TOK_KEY);
    localStorage.removeItem(REF_KEY);
    localStorage.removeItem(ROLE_KEY);
}
export async function api(path, init = {}, withAuth = true) {
    const headers = {
        'Content-Type': 'application/json',
        ...init.headers,
    };
    if (withAuth) {
        const t = getAccess();
        if (t)
            headers.Authorization = `Bearer ${t}`;
    }
    const r = await fetch(`${BASE}${path}`, { ...init, headers });
    if (r.status === 401 && withAuth) {
        // try refresh once
        const ref = getRefresh();
        if (ref) {
            const rr = await fetch(`${BASE}/auth/refresh`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh_token: ref }),
            });
            if (rr.ok) {
                const j = await rr.json();
                setTokens(j.access_token, j.refresh_token, j.role);
                headers.Authorization = `Bearer ${j.access_token}`;
                const r2 = await fetch(`${BASE}${path}`, { ...init, headers });
                if (!r2.ok)
                    throw new Error(await r2.text());
                return r2.json();
            }
        }
        clearTokens();
        location.href = '/login';
        throw new Error('Unauthorized');
    }
    if (!r.ok)
        throw new Error(await r.text());
    if (r.status === 204)
        return undefined;
    return r.json();
}
